import {
  CursorPaginationValidationBaseSchema,
  SellerAPICursorPaginationValidationSchema,
  withCursorPaginationValidation,
} from '../shared/cursorPagination.js';
import {
  WEBHOOK_STATUS,
  WebhookStatusValidationEnum,
  WebhookSubscribableEventValidationEnum,
} from './enum.js';

const webhookListFilterFields = {
  status: WebhookStatusValidationEnum.optional().meta({
    description: `Only return webhooks with this status. Valid values: ${Object.values(WEBHOOK_STATUS).join(', ')}.`,
  }),
  event: WebhookSubscribableEventValidationEnum.optional().meta({
    description: 'Only return webhooks subscribed to this event, for example `payment.paid`.',
  }),
} as const;

// Same filters, two pagination bases: native numbers for the MCP tool, string
// coercion for URL query params in the Koa controller (see invoice/list.ts).
export const WebhookListQueryValidationSchema = withCursorPaginationValidation(
  CursorPaginationValidationBaseSchema.extend(webhookListFilterFields),
);

export const WebhookListSellerAPIQueryValidationSchema = withCursorPaginationValidation(
  SellerAPICursorPaginationValidationSchema.extend(webhookListFilterFields),
);
